import { AudioPlayer, ComponentAlignment, CornerRadius } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const AudioDemo = () => {
  const args = {
    padding: 16 as any,
    source: 'https://github.com/rafaelreis-hotmart/Audio-Sample-files/raw/master/sample.mp3',
    coverImage: 'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M5.jpg',
    title: 'Song Title',
    subtitle: 'Artist Name',
    supportingText: 'Album • 2023',
    cornerRadius: 'medium' as CornerRadius,
    backgroundColor: 'primary-10',
    titleTypography: 'title-extra-small' as any,
    subtitleTypography: 'body-small' as any,
    supportingTextTypography: 'body-small' as any,
    timerTypography: 'label-medium' as any,
    width: 100,
    alignment: 'center' as ComponentAlignment,
    margin: 0,
  }
  const {
    width,
    alignment,
    margin,
    padding,
    titleTypography,
    subtitleTypography,
    supportingTextTypography,
    timerTypography,
    source,
    ...rest
  } = args
  return (
    <LayoutDemo
      title='Audio'
      bgColor='var(--color-primary-80)'
      // background='linear-gradient(45deg, var(--color-primary-60) 25%, transparent 21%) 0% 0% / 24px 24px, linear-gradient(315deg, var(--color-primary-60) 25%, transparent 21%) 0% 0% / 24px 24px, linear-gradient(45deg, var(--color-primary-10) 10%, transparent 11%) 0% 0% / 24px 24px, linear-gradient(315deg, var(--color-primary-10) 10%, transparent 11%) 0% 0% / 24px 24px,linear-gradient(135deg, var(--color-primary-60) 25%, transparent 21%) 0% 0% / 24px 24px, linear-gradient(225deg, var(--color-primary-60) 25%, transparent 21%) 0% 0% / 24px 24px, linear-gradient(135deg, var(--color-primary-10) 10%, transparent 11%) 0% 0% / 24px 24px, linear-gradient(225deg, var(--color-primary-10) 10%, transparent 11%) 0% 0% / 24px 24px, radial-gradient(var(--color-primary-10) 20%, transparent 21%) 0% 0% / 24px 24px'
      opacity={0.1}
    >
      <AudioPlayer
        id='audio-player'
        width={`${args.width}%`}
        alignment={args.alignment}
        margin={{
          top: `${margin}px`,
          right: `${margin}px`,
          bottom: `${margin}px`,
          left: `${margin}px`,
        }}
        padding={{
          top: `${padding}px`,
          right: `${padding}px`,
          bottom: `${padding}px`,
          left: `${padding}px`,
        }}
        {...rest}
        source={source}
        titleTypography={{ typography: titleTypography as any }}
        subtitleTypography={{ typography: subtitleTypography as any }}
        supportingTextTypography={{ typography: supportingTextTypography as any }}
        timerTypography={{ typography: timerTypography as any }}
        backgroundColor={'primary-90'}
      />
    </LayoutDemo>
  )
}
